/**
 * PreviewGallery — Image gallery grid
 */
import { RenderIcon } from './RenderIcon';

interface GalleryImage {
  url?: string;
  caption?: string;
}

interface PreviewGalleryProps {
  data: {
    title?: string;
    subtitle?: string;
    images?: GalleryImage[];
  };
  settings: {
    darkMode?: boolean;
    [key: string]: any;
  };
}

export function PreviewGallery({ data, settings }: PreviewGalleryProps) {
  return (
    <section className="preview-gallery">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div
          className="preview-gallery__grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
          }}
        >
          {data.images?.map((img, i) => (
            <div
              key={i}
              style={{
                aspectRatio: "4/3",
                background: settings.darkMode
                  ? "rgba(255,255,255,0.05)"
                  : "#e5e5e5",
                borderRadius: "12px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {img.url ? (
                <img
                  src={img.url}
                  alt={img.caption}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span style={{ opacity: 0.3 }}>
                  <RenderIcon name="image" />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
